import { render, staticRenderFns } from "./applyForTestDialog.vue?vue&type=template&id=bc105cde&scoped=true&"
import script from "./applyForTestDialog.vue?vue&type=script&lang=js&"
export * from "./applyForTestDialog.vue?vue&type=script&lang=js&"
import style0 from "./applyForTestDialog.vue?vue&type=style&index=0&id=bc105cde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc105cde",
  null
  
)

export default component.exports